

exports.__esModule = true;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _util = require('xo-return-to-merchant/dist/util');

var _logger = require('xo-beaver/dist/logger');

var _angular = require('angular');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoEmptyCartPageComponent', {
    tag: 'xo-empty-cart-page',
    template: _template2['default'],

    actions: {
        continueShopping: function continueShopping($event) {
            if ($event) {
                $event.preventDefault();
            }
            if (window.opener && !window.opener.closed) {
                _logger.$logger.info('continue_shopping_target_not_self');
                try {
                    window.opener.location.href = this.continueShoppingUrl;
                } catch (err) {
                    _logger.$logger.info('window_opener_location_error', { err: err });
                } finally {
                    self.close();
                }
            } else {
                _logger.$logger.info('continue_shopping_target_self');
                _util.$ReturnToMerchant.goTo(this.continueShoppingUrl);
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            angular.element('.merchantHeader').removeClass('showMerchantHeader');
            this.continueShoppingUrl = _angular.$rootScope.continueShoppingUrl;
        },
        populate: function populate() {
            // set focus to the message
            $('#emptyCart .message').focus();
        },
        exit: function exit() {
            angular.element('.merchantHeader').addClass('showMerchantHeader');
        }
    }

});


_squid.$Component;

_util.$ReturnToMerchant;

_logger.$logger;

_angular.$rootScope;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-empty-cart/directive.js
// module id = ./pages/xo-empty-cart/directive.js
// module chunks = 0